import { createFileRoute } from '@tanstack/react-router';
import { CompanyIdentityPage } from '../features/manage/company-settings-pages';
export const Route = createFileRoute('/manage/$companySlug/settings/company')({
  component: RouteComponent,
});
function RouteComponent() {
  const { companySlug } = Route.useParams();
  return <CompanyIdentityPage companySlug={companySlug} />;
}
